import Link from "next/link";
import Mark from "./Mark";
import { site } from "./site";

const SiteFooter = () => (
  <footer className="site-footer">
    <div className="wrap">
      <div className="footer-grid">
        <div className="footer-brand">
          <p className="brand brand-footer">
            <Mark />
            {site.name}
          </p>
          <a href={`mailto:${site.email}`}>{site.email}</a>
        </div>
        <nav className="footer-cols" aria-label="Footer">
          {site.footer.map((col) => (
            <div key={col.title}>
              <p className="footer-col-title">{col.title}</p>
              <ul>
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.href.startsWith("/") && !l.href.startsWith("/#") ? <Link href={l.href}>{l.label}</Link> : <a href={l.href}>{l.label}</a>}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>
      <p className="footer-legal">
        <span>© {new Date().getFullYear()} {site.legalName}</span>
        <span>
          Part of the Always Cool companies:{" "}
          {site.family.map((f) => (
            <a key={f.href} href={f.href}>
              {f.name}
            </a>
          ))}
        </span>
      </p>
    </div>
  </footer>
);

export default SiteFooter;
